import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantAddressAddRequest {
    merchantId?: number;
    description?: string;
    merchantCurrentBalanceTypeId?: number;
    merchantCurrentBalanceType?: number;
    amount?: number;
}

async function merchantCurrentBalanceMovementAdd(
    data: IMerchantAddressAddRequest
): Promise<any> {
    try {
        return (await axiosInstance.post("/MerchantCurrentBalanceMovement/Add", data))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useMerchantCurrentBalanceMovement() {
    return useMutation<any, Error, IMerchantAddressAddRequest>(
        (variables) => merchantCurrentBalanceMovementAdd(variables)
    );
}
 